/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialPaymentMethodOptionViewModel } from "../types/CourseFinancialPaymentMethodOptionViewModel.ts";
import { ePaymentMethodSchema } from "./ePaymentMethodSchema.ts";

export const courseFinancialPaymentMethodOptionViewModelSchema = z.object({
  paymentMethod: z.optional(
    z
      .lazy(() => ePaymentMethodSchema)
      .describe(
        "1 = Billet | 2 = CreditCardAprovaFacil | 3 = CreditCardMundiPagg | 4 = BankDeposit | 5 = CreditCardStripe | 6 = BilletPecegePay | 7 = CreditCardPecegePay | ",
      ),
  ),
  name: z
    .string()
    .describe("Nome da forma de pagamento no idioma corrente.")
    .nullish(),
  supportsInstallment: z.optional(
    z.boolean().describe("Indica se a forma de pagamento aceita parcelamento."),
  ),
}) as unknown as ToZod<CourseFinancialPaymentMethodOptionViewModel>;
